module.exports = __webpack_public_path__ + "static/media/statisticsBg.d741c7a4.png";